import { useState } from 'react';
import { Markdown } from './Markdown';

/** Collapse when source is longer than this (dense ops timeline). */
const FOLD_CHAR_THRESHOLD = 200;
/** Or when the markdown source spans more than this many lines. */
const FOLD_LINE_THRESHOLD = 4;

function shouldFold(text: string): boolean {
  if (text.length > FOLD_CHAR_THRESHOLD) return true;
  return text.split('\n').length > FOLD_LINE_THRESHOLD;
}

/**
 * Timeline note/comment body: long content starts collapsed with a
 * Show more / Show less control (same ghost affordance as Edit).
 */
export function FoldableMarkdown({ children }: { children: string }) {
  const foldable = shouldFold(children);
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="foldable-note">
      <div
        className={
          foldable && !expanded
            ? 'foldable-note-body is-collapsed'
            : 'foldable-note-body'
        }
      >
        <Markdown>{children}</Markdown>
      </div>
      {foldable && (
        <button
          type="button"
          className="btn btn-sm btn-ghost foldable-note-toggle"
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? 'Show less' : 'Show more'}
        </button>
      )}
    </div>
  );
}
